export default __webpack_public_path__ + "media/images/photoswipe-controls-c5683225ca9f55fd77cd08ca18307f42.png";